export default __webpack_public_path__ + "static/media/light-top.301ef59f.webp";